export default "__VITE_ASSET__BtAXg5nW__"